import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const mainCss = document.querySelector("link[data-main-css]");
const cssReady = new Promise((resolve) => {
  if (!mainCss || mainCss.rel === "stylesheet" && mainCss.sheet) return resolve();
  let done = false;
  const finish = () => { if (!done) { done = true; resolve(); } };
  // First "load" = preload finished (rel flips to stylesheet); second = stylesheet applied (sheet present).
  mainCss.addEventListener("load", () => { if (mainCss.sheet) finish(); });
  mainCss.addEventListener("error", finish, { once: true });
  setTimeout(finish, 2500);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
cssReady.then(() => root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
));
